import { useCallback, useEffect, useState } from 'react';

import { isMobile } from 'utils/isMobile';

declare global {
  interface Window {
    Firebug: {
      chrome: { isInitialized: boolean };
    };
  }
}

type Orientation = 'vertical' | 'horizontal';

type DevtoolsState = {
  isOpen: boolean;
  orientation: Orientation | undefined;
};

const THRESHOLD = 170;

export const useHandleDevTools = () => {
  const detectDevtools = useCallback((): DevtoolsState => {
    const widthThreshold = window.outerWidth - window.innerWidth > THRESHOLD;
    const heightThreshold = window.outerHeight - window.innerHeight > THRESHOLD;
    const orientation = widthThreshold ? 'vertical' : 'horizontal';
    const isMobileDevTool = /Mobi|Android|iPhone/i.test(navigator.userAgent);

    // for mobile dev tools
    if (isMobileDevTool) {
      return {
        isOpen: true,
        orientation
      };
    }

    // for desktop dev tools
    if (
      (!isMobile && window.Firebug && window.Firebug.chrome && window.Firebug.chrome.isInitialized) ||
      widthThreshold ||
      heightThreshold
    ) {
      return {
        isOpen: true,
        orientation
      };
    } else {
      return {
        isOpen: false,
        orientation: undefined
      };
    }
  }, []);

  const [isDevToolsOpen, setIsDevToolsOpen] = useState<boolean>(detectDevtools().isOpen);
  const [orientation, setOrientation] = useState<Orientation | undefined>(detectDevtools().orientation);

  useEffect(() => {
    const interval = setInterval(() => {
      const { isOpen, orientation } = detectDevtools();
      setIsDevToolsOpen(isOpen);
      setOrientation(orientation);
    }, 500);

    return () => {
      clearInterval(interval);
    };
  }, [detectDevtools]);

  return { isOpen: isDevToolsOpen, orientation };
};
